import React from 'react'
import SelectField from '../../formFields/selectField'
import { reduxFormFieldWrapper } from '../reduxFormFieldWrapper'

export default reduxFormFieldWrapper(fieldProps => (
  <SelectField {...fieldProps} />
))
